import React, { Component } from "react";
import Popup from "reactjs-popup";
import axios from 'axios';
import { Button } from "@progress/kendo-react-buttons";
import { Input } from "@progress/kendo-react-inputs";
import { parseDate } from '@telerik/kendo-intl';
import { TabStrip, TabStripTab } from "@progress/kendo-react-layout";
import ReactLoading from 'react-loading';

class EntityPopup extends Component {

  constructor(props) {
    super(props);


    this.state = {
      updates: [],
      EntityCode: '',
      billingEntries: {},
      demographics: {}
    }
  }

  componentDidMount() {

  }

  onOpen() {
    if (this.props.create) {
      this.getBillingClassesNewEntry()
    }
    else {
      this.setState({ EntityCode: this.props.dataRow.EntityCode, perfClassificationCode: this.props.dataRow.PerfClassificationCode });
      this.getBilling();
      this.getBillingClasses();
      this.getDemographics();
    }


  }

  getBillingClasses = () => {
    this.setState({ classesLoaded: false })
    var headers = { 'authorization': 'Bearer '.concat(this.props.idToken) };

    console.log(this.props.dataRow)

    axios(`api/billingEntityClasses`, {
      method: 'GET',
      params: {
        company: this.props.user.company,
        entity: this.props.dataRow.EntityCode,
        date: this.props.dataRow.RunDate,
      },
      headers: headers,
    })
      .then(response => {
        console.log(response)


        var classIndex = response.data.data.findIndex(c => c.PerfClassificationCode === this.props.dataRow.PerfClassificationCode)
        if (classIndex === -1) { classIndex = 0 }

        this.setState({ classes: response.data.data, tabSelected: classIndex, classesLoaded: true })

      })
      .catch(err => {
        console.error(err);
      })
  }

  getBillingClassesNewEntry = () => {
    this.setState({ classesLoaded: false })
    var headers = { 'authorization': 'Bearer '.concat(this.props.idToken) };
    var entries = this.state.billingEntries

    axios(`api/billingEntityClassesNewEntry`, {
      method: 'GET',
      params: { company: this.props.user.company },
      headers: headers,
    })
      .then(response => {
        entries.RunDate = '03/01/1904'
        entries.totport = {}
        var classes = [{ PerfClassificationCode: 'totport', PerfClassificationType: 'Total Portfolio' }]
        response.data.data.forEach(c => {
          entries[c.PerfClassificationCode] = {}
        })
        this.setState({ classes: classes.concat(response.data.data), billingEntries: entries, perfClassificationCode: 'totport', tabSelected: 0, classesLoaded: true })

      })
      .catch(err => {
        console.error(err);
      })
  }

  getDemographics = () => {
    this.setState({ demographicsLoaded: false })
    var headers = { 'authorization': 'Bearer '.concat(this.props.idToken) };

    console.log(this.props.dataRow)

    axios(`api/billingDemographicsEntity`, {
      method: 'GET',
      params: {
        company: this.props.user.company,
        entity: this.props.dataRow.EntityCode,
        date: this.props.dataRow.RunDate,
      },
      headers: headers,
    })
      .then(response => {
        console.log(response)
        this.setState({ demographics: response.data.data.length > 0 ? response.data.data[0] : {}, demographicsLoaded: true })

      })
      .catch(err => {
        console.error(err);
      })
  }

  getBilling = (assetClass) => {
    this.setState({ refreshText: 'Loading...' })
    var headers = { 'authorization': 'Bearer '.concat(this.props.idToken) };
    var billing = {};

    console.log(this.props.dataRow)

    var classificationCode = (assetClass ? assetClass : this.props.dataRow.PerfClassificationCode)
    console.log(classificationCode)

    axios(`api/billingEntity`, {
      method: 'GET',
      params: {
        company: this.props.user.company,
        entity: this.props.dataRow.EntityCode,
        date: this.props.dataRow.RunDate,
        assetClass: classificationCode,
      },
      headers: headers,
    })
      .then(response => {
        console.log(response)
        billing = response.data.data[0]

        billing.Bracket1 = this.numberWithCommas(billing.Bracket1)
        billing.Bracket2 = this.numberWithCommas(billing.Bracket2)
        billing.Bracket3 = this.numberWithCommas(billing.Bracket3)
        billing.Bracket4 = this.numberWithCommas(billing.Bracket4)
        billing.Bracket5 = this.numberWithCommas(billing.Bracket5)
        billing.RunDate = this.formatDate(billing.RunDate).toString()

        this.setState({ billing: billing, refreshText: '' })

      })
      .catch(err => {
        console.error(err);
      })
  }

  updateBilling(cb) {
    if (this.validate()) {
      this.setState({ refreshText: 'Loading...' })
      var headers = { 'authorization': 'Bearer '.concat(this.props.idToken) };

      var payload = {
        company: this.props.user.company,
        entity: this.state.EntityCode,
        perfClassificationCode: this.state.perfClassificationCode,
        date: this.props.dataRow.RunDate,
        updates: this.state.updates,
      };

      axios.post('api/billingEntity', payload, { headers }).then(response => {
        if (response.data.code === 200){
          cb()
          this.setState({ refreshText: '' })
        }
        else if (response.data.code === 301){
          alert('Entry already exists for this entity on this date')
          this.setState({ refreshText: '' })
        }

      })
        .catch(err => {
          console.error(err);
        })
    }
  }

  saveNewBilling(cb) {
    if (this.validate()) {
      this.setState({ refreshText: 'Loading...' })
      var headers = { 'authorization': 'Bearer '.concat(this.props.idToken) };

      var payload = {
        company: this.props.user.company,
        billingEntries: this.state.billingEntries,
      };

      axios.post('api/billingEntityNewEntry', payload, { headers }).then(response => {
        if (response.data.code === 200){
          cb()
          this.setState({ refreshText: '' })
        }
        else if (response.data.code === 301){
          alert('Entry already exists for this entity on this date')
          this.setState({ refreshText: '' })
        }

      })
        .catch(err => {
          console.error(err);
        })
    }
  }

  validate() {
    if (this.props.create) {
      var entry = this.state.billingEntries
      if (!entry.EntityCode) {
        alert('Entity Code is a required field')
        return false
      }
      if (!entry.RunDate) {
        alert('Run Date is a required field')
        return false
      }
      for (const assetClass in entry) {
        if (assetClass !== 'EntityCode' && assetClass !== 'RunDate' && Object.keys(entry[assetClass]).length > 0) {
          if (
            ((entry[assetClass].Bracket1 && !entry[assetClass].Rate0) || (!entry[assetClass].Bracket1 && entry[assetClass].Rate0)) ||
            ((entry[assetClass].Bracket2 && !entry[assetClass].Rate1) || (!entry[assetClass].Bracket2 && entry[assetClass].Rate1)) ||
            ((entry[assetClass].Bracket3 && !entry[assetClass].Rate2) || (!entry[assetClass].Bracket3 && entry[assetClass].Rate2)) ||
            ((entry[assetClass].Bracket4 && !entry[assetClass].Rate3) || (!entry[assetClass].Bracket4 && entry[assetClass].Rate3)) ||
            ((entry[assetClass].Bracket5 && !entry[assetClass].Rate4) || (!entry[assetClass].Bracket5 && entry[assetClass].Rate4))
          ) {
            alert('Brackets must have corresponding Rate value')
            return false
          }
        }
      }
    }
    else {
      for (var u of this.state.updates) {
        if (u.value && isNaN(u.value) 
          && u.field !== 'RunDate'
          && u.field !== 'AverageCost'
          && u.field !== 'Prorated'
        ) {
          alert('Values must be numeric')
          return false
        }
      }
    }

    return true
  }

  clearState = () => {
    this.setState({
      updates: [],
      EntityCode: '',
      billingEntries: {},
    });
  }

  onValueChange(field, value) {
    if (this.props.create) {
      var billingEntries = this.state.billingEntries

      if (field === 'RunDate' || field === 'EntityCode') {
        billingEntries[field] = value
      }
      else {
        billingEntries[this.state.perfClassificationCode][field] = value
      }
      console.log(billingEntries)
      console.log(this.state.perfClassificationCode)
      console.log(billingEntries[this.state.perfClassificationCode])
      this.setState({ billingEntries: billingEntries })

    }
    else {
      var updates = this.state.updates
      var billing = this.state.billing

      console.log(updates)
      console.log(billing)

      billing[field] = value
      const i = updates.findIndex(e => e.field === field);
      if (i > -1) {
        updates[i].value = value
      }
      else {
        updates.push({ field: field, value: value })
      }

      this.setState({ updates: updates, billing: billing })
    }

  }

  formatDate(date) {
    var d;

    if (parseDate(date, "yyyy-MM-ddTHH:mm:ss.SSSXXX")) { d = parseDate(date, "yyyy-MM-ddTHH:mm:ss.SSSXXX") }
    else { d = parseDate(date, "MM/dd/yyyy HH:mm:ss") }

    const day = String(d.getUTCDate()).padStart(2, '0');
    const month = String(d.getUTCMonth() + 1).padStart(2, '0'); // Month is 0-indexed
    const year = d.getUTCFullYear();

    return `${month}/${day}/${year}`;

  }

  handleSelect = (e) => {
    this.setState({
      tabSelected: e.selected,
      refreshText: this.props.create ? '' : 'Loading...',
      perfClassificationCode: this.state.classes[e.selected].PerfClassificationCode
    })
    if (!this.props.create) { this.getBilling(this.state.classes[e.selected].PerfClassificationCode) }
  }

  getStartingBracket(bracketString) {
    return bracketString ? (parseFloat(this.numberWithoutCommas(bracketString)) + 0.01) : ''
  }

  formatCurrency = (val) => {
    var formatted = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(val);
    return formatted;
  }

  numberWithCommas(x) {
    return x ? x.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",") : '';
  }

  numberWithoutCommas(x) {
    return x ? x.toString().replace(/,/g, "") : '';
  }

  processCommas(x) {//strip commas and add them back in the right places
    return this.numberWithCommas(this.numberWithoutCommas(x));
  }

  onValueBlur(value, field) {
    if (this.props.create) {
      var billingEntries = this.state.billingEntries

      billingEntries[this.state.perfClassificationCode][field] = this.processCommas(value)
      this.setState({ billingEntries: billingEntries })
    }
    else {
      var updates = this.state.updates
      var billing = this.state.billing

      console.log(updates)
      console.log(billing)

      billing[field] = this.processCommas(value)
      const i = updates.findIndex(u => u.field === field);
      if (i > -1) {
        updates[i].value = this.numberWithoutCommas(value)
      }
      else {
        updates.push({ field: field, value: this.numberWithoutCommas(value) })
      }

      this.setState({ updates: updates, billing: billing })
    }
  }

  render() {
    const addNew = this.props.create;
    const billing = this.state.billing;
    const entries = this.state.billingEntries;
    const demographics = this.state.demographics;

    return (
      <div className='billingPopup'>
        <Popup closeOnDocumentClick={false} trigger={this.props.button} onOpen={() => { this.onOpen(); }} onClose={() => { this.clearState(); this.props.refresh(); }} overlayStyle={{ zIndex: 5 }} modal >
          {close => (
            <div className="modal">
              <Button className="close" icon="close" onClick={(e) => { close(); }} />
              <div className="header" align="left">
                {addNew ? 'Create New' : 'Edit - ' + this.props.dataRow.EntityCode}
              </div>
              <div className="content">
                {(this.state.refreshText && !this.state.classesLoaded && !this.state.demographicsLoaded) &&
                  <div align='center'><ReactLoading type='spin' color='grey' height={100} width={100} /></div>
                }
                {(this.state.classesLoaded && (this.props.create || this.state.demographicsLoaded)) &&
                  <>
                    {!this.state.refreshText &&
                      <table style={{ paddingBottom: '10px' }}>
                        <tbody>
                          {addNew &&
                            <tr key={0}>
                              <td style={{ width: '70px' }}>Entity Code:</td>
                              <td><Input type="text" onChange={(e) => { this.onValueChange('EntityCode', e.target.value) }} value={addNew ? (entries.EntityCode ? entries.EntityCode : '') : (billing.EntityCode ? billing.EntityCode : '')} defaultValue={addNew ? '' : billing.EntityCode} /></td>
                            </tr>}
                          <tr key={1}>
                            <td style={{ width: '70px' }}>Run Date:</td>
                            <td><Input type="text" onChange={(e) => { this.onValueChange('RunDate', e.target.value) }} value={addNew ? (entries.RunDate ? entries.RunDate : '') : (billing.RunDate ? billing.RunDate : '')} defaultValue={addNew ? '03/01/1904' : billing.RunDate} /></td>
                          </tr>
                        </tbody>
                      </table>
                    }
                    <TabStrip selected={this.state.tabSelected} onSelect={this.handleSelect}>
                      {this.state.classes.map((assetClass, index) => (
                        <TabStripTab title={assetClass.PerfClassificationCode !== 'totport' ? assetClass.PerfClassificationCode : assetClass.PerfClassificationType}>
                          {this.state.refreshText && <div align='center'><ReactLoading type='spin' color='grey' height={100} width={100} /></div>}
                          {!this.state.refreshText &&
                            <div>

                              <table style={{ borderCollapse: 'collapse' }}>
                                <thead>
                                  <tr>
                                    <th style={{ width: '220px' }}></th>
                                    <th style={{ width: '60px' }}></th>
                                    <th style={{ width: '220px' }}>Brackets</th>
                                    <th>Rates</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr key={0}>
                                    <td>{'$0'}</td>
                                    <td>to</td>
                                    <td><Input type="text" defaultValue={addNew ? '' : billing.Bracket1} onBlur={(e) => { this.onValueBlur(e.target.value, 'Bracket1') }} value={addNew ? entries[assetClass.PerfClassificationCode].Bracket1 : billing.Bracket1} onChange={(e) => { this.onValueChange('Bracket1', e.target.value) }} style={{ width: '200px', textAlign: 'right' }} /></td>
                                    <td><Input type="text" defaultValue={addNew ? '' : billing.Rate0} value={addNew ? entries[assetClass.PerfClassificationCode].Rate0 : billing.Rate0} onChange={(e) => { this.onValueChange('Rate0', e.target.value) }} style={{ width: '80px', textAlign: 'right' }} /></td>
                                  </tr>
                                  <tr key={1}>
                                    <td>{addNew ? entries[assetClass.PerfClassificationCode].Bracket1 ? this.formatCurrency(this.getStartingBracket(entries[assetClass.PerfClassificationCode].Bracket1)) : '' : billing.Bracket1 ? this.formatCurrency(this.getStartingBracket(billing.Bracket1)) : ''}</td>
                                    <td>to</td>
                                    <td><Input type="text" defaultValue={addNew ? '' : billing.Bracket2} onBlur={(e) => { this.onValueBlur(e.target.value, 'Bracket2') }} value={addNew ? entries[assetClass.PerfClassificationCode].Bracket2 : billing.Bracket2} onChange={(e) => { this.onValueChange('Bracket2', e.target.value) }} style={{ width: '200px', textAlign: 'right' }} /></td>
                                    <td><Input type="text" defaultValue={addNew ? '' : billing.Rate1} value={addNew ? entries[assetClass.PerfClassificationCode].Rate1 : billing.Rate1} onChange={(e) => { this.onValueChange('Rate1', e.target.value) }} style={{ width: '80px', textAlign: 'right' }} /></td>
                                  </tr>
                                  <tr key={2}>
                                    <td>{addNew ? entries[assetClass.PerfClassificationCode].Bracket2 ? this.formatCurrency(this.getStartingBracket(entries[assetClass.PerfClassificationCode].Bracket2)) : '' : billing.Bracket2 ? this.formatCurrency(this.getStartingBracket(billing.Bracket2)) : ''}</td>
                                    <td>to</td>
                                    <td><Input type="text" defaultValue={addNew ? '' : billing.Bracket3} onBlur={(e) => { this.onValueBlur(e.target.value, 'Bracket3') }} value={addNew ? entries[assetClass.PerfClassificationCode].Bracket3 : billing.Bracket3} onChange={(e) => { this.onValueChange('Bracket3', e.target.value) }} style={{ width: '200px', textAlign: 'right' }} /></td>
                                    <td><Input type="text" defaultValue={addNew ? '' : billing.Rate2} value={addNew ? entries[assetClass.PerfClassificationCode].Rate2 : billing.Rate2} onChange={(e) => { this.onValueChange('Rate2', e.target.value) }} style={{ width: '80px', textAlign: 'right' }} /></td>
                                  </tr>
                                  <tr key={3}>
                                    <td>{addNew ? entries[assetClass.PerfClassificationCode].Bracket3 ? this.formatCurrency(this.getStartingBracket(entries[assetClass.PerfClassificationCode].Bracket3)) : '' : billing.Bracket3 ? this.formatCurrency(this.getStartingBracket(billing.Bracket3)) : ''}</td>
                                    <td>to</td>
                                    <td><Input type="text" defaultValue={addNew ? '' : billing.Bracket4} onBlur={(e) => { this.onValueBlur(e.target.value, 'Bracket4') }} value={addNew ? entries[assetClass.PerfClassificationCode].Bracket4 : billing.Bracket4} onChange={(e) => { this.onValueChange('Bracket4', e.target.value) }} style={{ width: '200px', textAlign: 'right' }} /></td>
                                    <td><Input type="text" defaultValue={addNew ? '' : billing.Rate3} value={addNew ? entries[assetClass.PerfClassificationCode].Rate3 : billing.Rate3} onChange={(e) => { this.onValueChange('Rate3', e.target.value) }} style={{ width: '80px', textAlign: 'right' }} /></td>
                                  </tr>
                                  <tr key={4}>
                                    <td>{addNew ? entries[assetClass.PerfClassificationCode].Bracket4 ? this.formatCurrency(this.getStartingBracket(entries[assetClass.PerfClassificationCode].Bracket4)) : '' : billing.Bracket4 ? this.formatCurrency(this.getStartingBracket(billing.Bracket4)) : ''}</td>
                                    <td>to</td>
                                    <td><Input type="text" defaultValue={addNew ? '' : billing.Bracket5} onBlur={(e) => { this.onValueBlur(e.target.value, 'Bracket5') }} value={addNew ? entries[assetClass.PerfClassificationCode].Bracket5 : billing.Bracket5} onChange={(e) => { this.onValueChange('Bracket5', e.target.value) }} style={{ width: '200px', textAlign: 'right' }} /></td>
                                    <td><Input type="text" defaultValue={addNew ? '' : billing.Rate4} value={addNew ? entries[assetClass.PerfClassificationCode].Rate4 : billing.Rate4} onChange={(e) => { this.onValueChange('Rate4', e.target.value) }} style={{ width: '80px', textAlign: 'right' }} /></td>
                                  </tr>
                                  <tr key={5}>
                                    <td>{addNew ? entries[assetClass.PerfClassificationCode].Bracket5 ? this.formatCurrency(this.getStartingBracket(entries[assetClass.PerfClassificationCode].Bracket5)) : '' : billing.Bracket5 ? this.formatCurrency(this.getStartingBracket(billing.Bracket5)) : ''}</td>
                                    <td colSpan="2">and above</td>
                                    <td><Input type="text" defaultValue={addNew ? '' : billing.Rate5} value={addNew ? entries[assetClass.PerfClassificationCode].Rate5 : billing.Rate5} onChange={(e) => { this.onValueChange('Rate5', e.target.value) }} style={{ width: '80px', textAlign: 'right' }} /></td>
                                  </tr>
                                </tbody>
                              </table>

                              <table style={{ paddingTop: '25px' }}>
                                <tbody>
                                  <tr key={0}>
                                    <td>Average Cost:</td>
                                    <td><Input type="text" onChange={(e) => { this.onValueChange('AverageCost', e.target.value) }} defaultValue={addNew ? 'n' : billing.AverageCost} /></td>
                                    <td>Pro Rated:</td>
                                    <td><Input type="text" onChange={(e) => { this.onValueChange('Prorated', e.target.value) }} defaultValue={addNew ? 'n' : billing.Prorated} /></td>
                                  </tr>
                                  <tr key={1}>
                                    <td>Billing Method:</td>
                                    <td><Input type="text" disabled={true} defaultValue={addNew ? '' : demographics.BillingMethod} /></td>
                                    <td>Flat Fee:</td>
                                    <td><Input type="text" disabled={true} defaultValue={addNew ? '' : demographics.FlatFee} /></td>
                                  </tr>
                                  <tr key={2}>
                                    <td>Payment Period:</td>
                                    <td><Input type="text" disabled={true} defaultValue={addNew ? '' : demographics.PaymentPeriod} /></td>
                                    <td>Minimum Fee:</td>
                                    <td><Input type="text" disabled={true} defaultValue={addNew ? '' : demographics.MinimumFee} /></td>
                                  </tr>
                                  <tr key={3}>
                                    <td>Past Due:</td>
                                    <td><Input type="text" disabled={true} defaultValue={addNew ? '' : demographics.PastDue} /></td>
                                    <td>Tax Rate:</td>
                                    <td><Input type="text" disabled={true} defaultValue={addNew ? '' : demographics.TaxRate} /></td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          }
                        </TabStripTab>
                      ))}
                    </TabStrip>
                  </>
                }
              </div>
              <div className="actions">
                <Button
                  className="button"
                  onClick={() => { close(); }}>
                  Cancel
                </Button>
                <Button
                  className="upload"
                  onClick={() => { addNew ? this.saveNewBilling(() => { close(); }) : this.updateBilling(() => { close(); }) }}>
                  {this.props.create ? 'Save' : 'Update'}
                </Button>
              </div>
            </div>
          )}
        </Popup>
      </div>
    );
  };
}

export default EntityPopup;